{
  "version": 13,
  "curve": "arc",
  "radiusMeters": 30,
  "crashHarshness": 1.5,
  "turnTax": 0,
  "lines": {
    "trail": true,
    "moveLine": true,
    "prediction": true,
    "windGhost": false
  },
  "wind": {
    "coefficient": 0.05,
    "exposure": 1,
    "lowSpeedMultiplier": 2,
    "offsetCapM": 10
  },
  "previewGates": true,
  "showLog": true,
  "stickyEdges": true,
  "stickyOverflowPx": 40,
  "nearMissPx": 28,
  "trailLengthMeters": 25,
  "trailSpeedGain": 1.5,
  "camera": {
    "enabled": true,
    "placeZoom": 1,
    "restZoom": 0.75,
    "fastZoom": 0.55,
    "speedSensitivity": 1.4,
    "lookAhead": 0.5,
    "aimBias": 0.18,
    "paddingM": 4,
    "circleFit": 0.35,
    "fitBlend": 0.4,
    "smoothness": 8,
    "smoothnessIn": 4.5,
    "minAutoZoom": 0.25,
    "maxAutoZoom": 2
  }
}
